import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

export const Colors = {
  AZUL: "#0c478af6",
  AMARELO: "#FDB913",
  BLACK: "#0a0a1dff",
  VERMELHO: "#cd0028",
  VERDE: "#007932",
};

export const theme = createTheme({
  palette: {
    background: {
      default: "#eff0f1ff", 
    },
    primary: {
      main: "#133859",
    },
    secondary: {
      main:"#00d2f7",
    },
    error: {
      main: red.A400,
    },
    warning: {
      main: "#ed6c02",
      light: "#ff9800",
      dark: "#e65100",
    },
    success: {
      main: "#2e7d32",
      light: "#4caf50",
      dark: "#1b5e20",
    },
    info: {
      main: "#2B5DC6",
      light: "#557dd1",
      dark: "#1e418a",
    },
  },
  typography: {
    fontFamily: [
      "Montserrat",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          background: "#FFFFFF",
          borderWidth: 1,
          borderColor: "#ECEEF4",
          boxShadow: "none",
        },
      },
    },
    
  },
});
